/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatMessage } from '../models/ChatMessage';
import type { ChatMessageFeedback } from '../models/ChatMessageFeedback';
import type { ChatMessageIssue } from '../models/ChatMessageIssue';
import type { ChatThread } from '../models/ChatThread';
import type { ChatThreadListResponse } from '../models/ChatThreadListResponse';
import type { CreateFeedbackRequest } from '../models/CreateFeedbackRequest';
import type { CreateIssueRequest } from '../models/CreateIssueRequest';
import type { CreateMessageRequest } from '../models/CreateMessageRequest';
import type { CreateThreadRequest } from '../models/CreateThreadRequest';
import type { GenerateAssistantResponseRequest } from '../models/GenerateAssistantResponseRequest';
import type { ListThreadsRequest } from '../models/ListThreadsRequest';
import type { UpdateThreadRequest } from '../models/UpdateThreadRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ChatService {

    /**
     * List threads for the authenticated user
     * @returns ChatThreadListResponse Success
     * @throws ApiError
     */
    public static listChatThreads({
        requestBody,
    }: {
        requestBody: ListThreadsRequest,
    }): CancelablePromise<ChatThreadListResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/threads/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Create a new chat thread
     * @returns ChatThread Created
     * @throws ApiError
     */
    public static createChatThread({
        requestBody,
    }: {
        requestBody: CreateThreadRequest,
    }): CancelablePromise<ChatThread> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/threads',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get a chat thread with its messages
     * @returns ChatThread Success
     * @throws ApiError
     */
    public static getChatThread({
        id,
    }: {
        /**
         * Thread UUID
         */
        id: string,
    }): CancelablePromise<ChatThread> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/threads/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Rename, pin, or unpin a chat thread
     * @returns ChatThread Success
     * @throws ApiError
     */
    public static updateChatThread({
        id,
        requestBody,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        requestBody: UpdateThreadRequest,
    }): CancelablePromise<ChatThread> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/chat/threads/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete a chat thread and all its messages
     * @returns void
     * @throws ApiError
     */
    public static deleteChatThread({
        id,
    }: {
        /**
         * Thread UUID
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/chat/threads/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add a message to a chat thread
     * @returns ChatMessage Created
     * @throws ApiError
     */
    public static createChatMessage({
        id,
        requestBody,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        requestBody: CreateMessageRequest,
    }): CancelablePromise<ChatMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/threads/{id}/messages',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Generate an assistant response for a chat thread (SSE stream)
     * @returns string SSE stream of assistant response
     * @throws ApiError
     */
    public static generateAssistantResponse({
        id,
        requestBody,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        requestBody: GenerateAssistantResponseRequest,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/threads/{id}/generateAssistantResponse',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get feedback for a message
     * @returns ChatMessageFeedback Success
     * @throws ApiError
     */
    public static getChatMessageFeedback({
        id,
        messageId,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        /**
         * Message UUID
         */
        messageId: string,
    }): CancelablePromise<ChatMessageFeedback> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/threads/{id}/messages/{messageId}/feedback',
            path: {
                'id': id,
                'messageId': messageId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create or update feedback for a message
     * @returns ChatMessageFeedback Success
     * @throws ApiError
     */
    public static upsertChatMessageFeedback({
        id,
        messageId,
        requestBody,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        /**
         * Message UUID
         */
        messageId: string,
        requestBody: CreateFeedbackRequest,
    }): CancelablePromise<ChatMessageFeedback> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/threads/{id}/messages/{messageId}/feedback',
            path: {
                'id': id,
                'messageId': messageId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete feedback for a message
     * @returns void
     * @throws ApiError
     */
    public static deleteChatMessageFeedback({
        id,
        messageId,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        /**
         * Message UUID
         */
        messageId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/chat/threads/{id}/messages/{messageId}/feedback',
            path: {
                'id': id,
                'messageId': messageId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List issues for a message
     * @returns ChatMessageIssue Success
     * @throws ApiError
     */
    public static listChatMessageIssues({
        id,
        messageId,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        /**
         * Message UUID
         */
        messageId: string,
    }): CancelablePromise<Array<ChatMessageIssue>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/threads/{id}/messages/{messageId}/issues',
            path: {
                'id': id,
                'messageId': messageId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create an issue for a message
     * @returns ChatMessageIssue Created
     * @throws ApiError
     */
    public static createChatMessageIssue({
        id,
        messageId,
        requestBody,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        /**
         * Message UUID
         */
        messageId: string,
        requestBody: CreateIssueRequest,
    }): CancelablePromise<ChatMessageIssue> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/threads/{id}/messages/{messageId}/issues',
            path: {
                'id': id,
                'messageId': messageId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get an issue by id
     * @returns ChatMessageIssue Success
     * @throws ApiError
     */
    public static getChatMessageIssue({
        id,
        messageId,
        issueId,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        /**
         * Message UUID
         */
        messageId: string,
        /**
         * Issue UUID
         */
        issueId: string,
    }): CancelablePromise<ChatMessageIssue> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/threads/{id}/messages/{messageId}/issues/{issueId}',
            path: {
                'id': id,
                'messageId': messageId,
                'issueId': issueId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete an issue
     * @returns void
     * @throws ApiError
     */
    public static deleteChatMessageIssue({
        id,
        messageId,
        issueId,
    }: {
        /**
         * Thread UUID
         */
        id: string,
        /**
         * Message UUID
         */
        messageId: string,
        /**
         * Issue UUID
         */
        issueId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/chat/threads/{id}/messages/{messageId}/issues/{issueId}',
            path: {
                'id': id,
                'messageId': messageId,
                'issueId': issueId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

}
